import React, {Component} from 'react'
import FilterOrderNumber from './FilterOrderNumber'
import FilterDateReport from './FilterDateReport'
import FilterReason from './FilterReason'
import FilterStatus from './FilterStatus'

class ReGenerateFilters extends Component{
    render() {
        return (
            <div className="ReGenerateFilters mb-3 pt-3 pl-3 pr-3">
                <div className="d-flex align-items-center">
                    <FilterOrderNumber {...this.props}/>
                    <FilterReason {...this.props}/>
                    <FilterDateReport {...this.props}/>
                    <FilterStatus {...this.props}/>
                </div>
            </div>
        )
    }
}

export default ReGenerateFilters